export default {
      id: "warning-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.1793797381340.svg#warning-usage",
      toString: function () {
        return this.url;
      }
    }